import { useState, useRef } from 'react';
import api from '../services/api';

// Estado/lógica do F3 — Busca Avançada de Produtos, compartilhado entre o
// PDV e o Cadastro de Produtos (mesmo modal, ModalBuscaProdutos.jsx). Cada
// tela injeta seu próprio `confirmarF3` (o que fazer com o produto
// escolhido — adicionar ao carrinho no PDV, carregar pra edição no
// Cadastro) e, opcionalmente, `aoFalhaSemRede` (fallback ao cache offline —
// só faz sentido no PDV, onde uma venda não pode travar por falta de rede).
export const FILTROS_F3_VAZIOS = {
  codigo: '', descricao: '', tributacao: '', aplicacao: '',
  cod_barras: '', aliq_icms: '', grupo_id: '', subgrupo_id: '',
  marca_id: '', fornecedor_id: '', ncm: '', unidade: '', plataforma: '',
  ver_inativos: false, balanca: false, estoque_min: false,
  estoque_neg: false, marcador: false, sem_cest: false,
  sem_ncm: false, consignacao: false, margem_zero: false,
  composto: false, servico: false,
};

export default function useBuscaProdutosF3({ aoFechar, aoFalhaSemRede } = {}) {
  const [modalF3, setModalF3]             = useState(false);
  const [filtrosF3, setFiltrosF3]         = useState(FILTROS_F3_VAZIOS);
  const [produtosF3, setProdutosF3]       = useState([]);
  const [buscandoF3, setBuscandoF3]       = useState(false);
  const [idxF3, setIdxF3]                 = useState(null);
  const [buscaRapidaF3, setBuscaRapidaF3] = useState('');
  const buscaRapidaRef = useRef(null);
  const debF3Ref = useRef(null);

  const fecharF3 = () => {
    setModalF3(false);
    aoFechar?.();
  };

  const buscarF3 = async (filtros, rapida = '') => {
    setBuscandoF3(true);
    setIdxF3(null);
    try {
      const params = {};
      // "Código" e "Descrição" eram o MESMO parâmetro (`busca`) — um sempre
      // pisava no outro quando os dois vinham preenchidos. Agora "Código"
      // tem parâmetro dedicado (início do código interno); `busca` fica só
      // pra descrição/busca rápida (mesma prioridade de antes: descrição
      // pisa na busca rápida se os dois vierem preenchidos).
      if (rapida)                params.busca = rapida;
      if (filtros.descricao)     params.busca = filtros.descricao;
      if (filtros.codigo)        params.codigo = filtros.codigo;
      if (filtros.aplicacao)     params.aplicacao = filtros.aplicacao;
      if (filtros.aliq_icms)     params.aliq_icms = filtros.aliq_icms;
      if (filtros.plataforma)    params.plataforma = filtros.plataforma;
      if (filtros.unidade)       params.unidade = filtros.unidade;
      if (filtros.grupo_id)      params.grupo_id = filtros.grupo_id;
      if (filtros.subgrupo_id)   params.subgrupo_id = filtros.subgrupo_id;
      if (filtros.marca_id)      params.marca_id = filtros.marca_id;
      if (filtros.fornecedor_id) params.fornecedor_id = filtros.fornecedor_id;
      if (filtros.ncm)           params.ncm = filtros.ncm;
      if (filtros.sem_ncm)       params.sem_ncm = 'true';
      if (filtros.margem_zero)  params.margem_zero = 'true';
      if (filtros.composto)      params.composto = 'true';
      // "Balança" = atributo "Produto de balança" do cadastro (o que vai pra
      // balança etiquetadora), não "Pesado no caixa".
      if (filtros.balanca)       params.produto_balanca = 'true';
      if (filtros.estoque_min)   params.abaixo_minimo = 'true';
      if (filtros.marcador)      params.marcador = 'true';
      if (filtros.sem_cest)      params.sem_cest = 'true';
      if (filtros.consignacao)   params.consignacao = 'true';
      if (filtros.servico)       params.tipo = 'serviço';
      if (filtros.cod_barras)    params.cod_barras = filtros.cod_barras;
      if (filtros.tributacao)    params.tributacao = filtros.tributacao;
      if (filtros.estoque_neg)   params.estoque_status = 'negativo';
      if (filtros.ver_inativos)  params.inativo = 'true';
      params.todos = 'true';
      const { data } = await api.get('/produtos', { params });
      setProdutosF3(Array.isArray(data) ? data : (data.produtos || []));
    } catch (err) {
      if (!err.response && aoFalhaSemRede) {
        const termo = rapida || filtros.codigo || filtros.descricao || '';
        setProdutosF3((await aoFalhaSemRede(termo)) || []);
      } else {
        setProdutosF3([]);
      }
    } finally {
      setBuscandoF3(false);
    }
  };

  const handleBuscaRapidaF3 = e => {
    const v = e.target.value;
    setBuscaRapidaF3(v);
    clearTimeout(debF3Ref.current);
    debF3Ref.current = setTimeout(() => buscarF3(filtrosF3, v), 350);
  };

  const setFiltro = (campo, valor) =>
    setFiltrosF3(prev => ({ ...prev, [campo]: valor }));

  const abrirF3 = () => {
    setModalF3(true);
    setFiltrosF3(FILTROS_F3_VAZIOS);
    setIdxF3(null);
    setBuscaRapidaF3('');
    setProdutosF3([]);
    setTimeout(() => buscaRapidaRef.current?.focus(), 60);
  };

  return {
    modalF3, setModalF3, filtrosF3, setFiltrosF3, setFiltro,
    produtosF3, setProdutosF3, buscandoF3, idxF3, setIdxF3,
    buscaRapidaF3, setBuscaRapidaF3, buscaRapidaRef,
    fecharF3, buscarF3, handleBuscaRapidaF3, abrirF3,
  };
}
